<template>
<div class="chapter">
<div class="inner_page">
<div class="section" id="section007">
<div class="pseudo_margin_2"></div>
<div class="pseudo_margin_2"></div>
<p class="poem_title1" id="ch1"><span class="right_1" epub:type="pagebreak" id="page_2" title="2"><span class="right_1" epub:type="pagebreak" id="page_3" title="3">THE DEBT</span></span></p>
<div class="pseudo_margin_2"></div>
<div class="pseudo_margin_1"></div>
<p class="negative_indent_2">He entered through the doorway of his debt.</p>
<p class="negative_indent_2">Workmen followed, bringing box after box</p>
<div class="pseudo_margin_1"></div>
<p class="negative_indent_2">until everything he’d gathered in his life</p>
<p class="negative_indent_2">inhabited his debt. He opened the sliding door to the yard—</p>
<div class="pseudo_margin_1"></div>
<p class="negative_indent_2">a breeze blew through the spaces of his debt,</p>
<p class="negative_indent_2">blew the bills from the table onto the floor.</p>
<div class="pseudo_margin_1"></div>
<p class="negative_indent_2">The grove of birches and, farther,</p>
<p class="negative_indent_2">the beach of driftwood and broken shells</p>
<div class="pseudo_margin_1"></div>
<p class="negative_indent_2">were framed by the enormous window—</p>
<p class="negative_indent_2">that lenslike architectural focus of his debt.</p>
<div class="pseudo_margin_1"></div>
<p class="negative_indent_2">He drove into town on the coiled springs</p>
<p class="negative_indent_2">of his debt; when he bought fish at the market</p>
<div class="pseudo_margin_1"></div>
<p class="negative_indent_2">he proffered his MasterCard. The dark woods</p>
<p class="negative_indent_2">stretching inland were pocked by lightfilled cubes</p>
<div class="pseudo_margin_1"></div>
<p class="negative_indent_2">of debt. The very words he used to describe</p>
<p class="negative_indent_2">his surroundings were glittering facets</p>
<div class="pseudo_margin_1"></div>
<p class="negative_indent_2"><span class="right_1" epub:type="pagebreak" id="page_4" title="4">of debt. Each visit, we smoked on the deck</span></p>
<p class="negative_indent_2">and, over drinks, he reminded me</p>
<div class="pseudo_margin_1"></div>
<p class="negative_indent_2">with love and genuine pride: one day</p>
<p class="negative_indent_2">all this debt would be mine.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter01.vue?8019bbba